// registration-wizard/helpers.ts
import { FacilitatorModelView, CourseDateModelView } from '@actschurch/ccms-sdk';
import { ParticipantDraft } from './types';

export const emptyParticipant = (): ParticipantDraft => ({
  memberID:   null,
  name:       '',
  surname:    '',
  email:      '',
  phone:      '',
  gender:     null,
  isMain:     false,
  hasConsent: false,
  resolved:   false,
});

export const facilitatorName = (f: FacilitatorModelView) =>
  [f.firstName, f.surname].filter(Boolean).join(' ').trim() ||
  f.displayName?.trim() || f.fullName?.trim() || f.userId;

// Build a human-readable label for a course date:
// "12 Jul – 20 Sep 2026  ·  Weekly  ·  Remote" (or location name)
export const dateLabelParts = (d: CourseDateModelView): string => {
  const parts: string[] = [];
  if (d.periodDisplay ?? d.startDisplay)
    parts.push(d.periodDisplay ?? d.startDisplay ?? '');
  if (d.frequency)
    parts.push(d.frequency);
  if (d.modeDisplay ?? (d.isRemote ? 'Remote' : d.locationName))
    parts.push(d.modeDisplay ?? (d.isRemote ? 'Remote' : d.locationName ?? ''));
  return parts.filter(Boolean).join('  ·  ');
};